import { render, staticRenderFns } from "./phone-input-wrap.vue?vue&type=template&id=debeadbc&scoped=true&"
import script from "./phone-input-wrap.vue?vue&type=script&lang=js&"
export * from "./phone-input-wrap.vue?vue&type=script&lang=js&"
import style0 from "./phone-input-wrap.vue?vue&type=style&index=0&id=debeadbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debeadbc",
  null
  
)

export default component.exports